export interface GroupAPIError {
  message: string;
  error_code: string;
}

export enum GroupsStatus {
  ONLINE = 'online',
  OFFLINE = 'offline'
}

export enum GroupObjectType {
  IN_CLASS = 1,
  COMBAT = 2,
  TAKING_A_QUIZ = 3,
  TAKING_A_TEST = 4,
  PRACTICING = 5,
  READING_NOTES = 6
}

/**
 * 0 - Past
 * 1 - Current / Present
 */
type LatestActivityStatusType = 0 | 1;

interface BaseActivity {
  objectType: GroupObjectType;
  status: LatestActivityStatusType;
  data: any;
}

export interface IClassActivity extends BaseActivity {
  objectType: GroupObjectType.IN_CLASS;
  data: {
    uid: string;
    title: string;
  };
}

export interface IPracticingActivity extends BaseActivity {
  objectType: GroupObjectType.PRACTICING;
  data: {
    topicGroupUid: string;
    title: string;
    topicGroupName?: string;
  };
}

export type ILatestActivity =
  | BaseActivity
  | IClassActivity
  | IPracticingActivity;

export interface IGroupUser {
  uid: string;
  avatar: string;
  name: string;
  firstName: string;
  lastName: string;
  username?: string;
  inviteLink?: string;
  watchMins: number;
  joinedAt: number;
  totalWins: number;
  watchMinsThreshold: number;
  questionsAttempted: number;
  questionsAttemptThreshold: number;
  status?: GroupsStatus;
  latestActivity: ILatestActivity | {};
  dailyTasks?: any;
}

export interface ILeaderboardUser {
  uid: string;
  firstName: string;
  lastName: string;
  points: number;
  position: number;
  avatar: string;
}

export interface IGroupsReducerState {
  data: {
    [goalUID: string]: {
      loading?: boolean;
      error?: boolean | GroupAPIError;
      isGroupNew?: boolean;
      groupUID?: string;
      users?: {
        loading: boolean;
        error?: boolean | GroupAPIError;
        data: IGroupUser[];
      };
      itemInfo?: {
        [itemUID: string]: {
          loading: boolean;
          error?: boolean | GroupAPIError;
          data: any;
        };
      };
      startDate?: string;
      endDate?: string;
      currentDate?: string;
      leaderboard?: ILeaderboardUser[];
      scoreboard?: {
        loading: boolean;
        error?: boolean | GroupAPIError;
        data: ILeaderboardUser[];
      };
      selectedUser?: {
        loading: boolean;
        error?: boolean | GroupAPIError;
        data: IGroupUser;
      };
    };
  };
  inviteData: {
    isInvitationReceived?: boolean;
    invitee?: any;
    error?: any | boolean;
  };
}
